import { render, staticRenderFns } from "./LabsOrders.vue?vue&type=template&id=2e7f5fba&"
import script from "./LabsOrders.vue?vue&type=script&lang=js&"
export * from "./LabsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports